import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { maintainMessage as maintainMessageSelector } from './selectors';
import MaintainMessage from './MaintainMessage/MaintainMessage';

export function InProductMessagesContainer({ maintainMessage }) {
  return maintainMessage ? <MaintainMessage message={maintainMessage} /> : null;
}

InProductMessagesContainer.propTypes = {
  maintainMessage: PropTypes.string,
};

function mapStateToProps(state) {
  return {
    maintainMessage: maintainMessageSelector(state),
  };
}

export default connect(mapStateToProps, null)(InProductMessagesContainer);
